var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgraundPawprintYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31154_5357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.3207 128.378C103.38 129.528 115.961 124.022 123.976 113.65C131.991 103.277 134.143 89.7133 129.734 77.368L119.113 47.6181C117.352 42.6825 114.116 38.5328 109.759 35.6197C105.401 32.7059 100.331 31.303 95.0935 31.5599C89.8577 31.8209 84.9499 33.7192 80.9004 37.0494C76.8508 40.3795 74.0422 44.8306 72.7767 49.9192L72.6931 50.2609C69.4253 63.0006 60.9481 73.8934 49.3893 80.1875C46.4079 81.8115 43.848 83.9946 41.8165 86.6238C40.712 88.0532 39.7632 89.6166 38.987 91.2922C36.7855 96.0502 36.187 101.278 37.2558 106.412C38.3252 111.543 40.9623 116.097 44.8817 119.581C48.801 123.064 53.632 125.147 58.8543 125.608L90.3207 128.378Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.377 67.5331C135.818 72.7373 136.696 78.2848 139.851 83.1537C142.852 87.7876 147.597 91.264 153.212 92.9425C158.825 94.6179 164.699 94.3145 169.752 92.0888C175.059 89.7501 178.839 85.596 180.39 80.3963C183.519 69.9413 176.416 58.5461 164.551 54.9916C155.1 52.1727 145.443 55.1692 140.328 61.7897C139.022 63.4802 138.012 65.4071 137.377 67.5331Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.64 106.447C125.855 116.524 128.86 131.938 140.34 140.809C151.824 149.682 167.5 148.702 175.286 138.625C183.071 128.55 180.062 113.134 168.579 104.262C157.099 95.3912 141.426 96.3717 133.64 106.447Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.14 134.053L104.139 134.054C102.427 135.207 100.96 136.598 99.743 138.173C94.065 145.521 93.8801 156.815 99.9885 165.899C103.504 171.129 108.587 174.891 114.3 176.492C120.281 178.169 126.227 177.308 131.046 174.068C135.865 170.826 138.905 165.643 139.607 159.472C140.279 153.577 138.711 147.451 135.193 142.223C127.775 131.193 113.845 127.528 104.14 134.053Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8341 174.415L76.8392 174.415C87.3415 171.432 93.1467 159.32 89.7785 147.412C86.402 135.506 75.1125 128.237 64.6144 131.206C60.7846 132.288 57.5783 134.586 55.2138 137.646C51.0929 142.98 49.5276 150.632 51.6675 158.209C55.0446 170.114 66.3334 177.384 76.8341 174.415Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31154_5357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.222,
    height: 157.222,
    fill: "white",
    transform: "translate(220.539 96.1284) rotate(127.692)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgraundPawprintYellow);
export default __webpack_public_path__ + "static/media/backgraund-pawprint-yellow.c3e3c66a2f35661a16d74ae04102b4c5.svg";
export { ForwardRef as ReactComponent };